import MemberExportHistory from "@/views/MGT/member/components/member-export-history.vue";
import exportExcel from "@/utils/export-execel";
import store from "store2";
export default {
  name: "member-importand-export",
  components: {
    MemberExportHistory
  },
  props: {
    value: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      downLoading: false,
      history: {
        visible: false
      },
      update: {
        action: "/api/file/addressBookImport",
        headers: {
          Authorization: localStorage.getItem("token"),
          // store2 会反序列化缓存值，避免 language 请求头携带 JSON 引号。
          language: store.get("language") || "zh-CN"
        },
        format: ["xls", "xlsx", "xlsm"],
        loading: false
      }
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  methods: {
    close() {
      this.update.loading = false;
      this.downLoading = false;
      this.visible = false;
    },
    onDownTemplate() {
      exportExcel("get", "/api/file/addressBookDownLoad");
    },
    onHistory() {
      this.history.visible = true;
    },
    onSuccessExport(res) {
      if (res.result === 0) {
        this.$Message.success(res.retVal);
        this.$emit("onSuccess");
        this.close();
      } else {
        this.$Message.error(res.msg);
      }
      this.update.loading = false;
    },
    onFormatError(file) {
      this.$Message.error(`${file.name}${$t('96n1wdb', '文件格式不符合，仅允许')}${this.update.format.join(",")}`);
      this.update.loading = false;
    },
    onErrorExport() {
      this.update.loading = false;
    },
    onBefor() {
      this.update.loading = true;
    }
  }
};